// モーダル・確認・トースト。モーダルは1枚ずつ重ねられる。Esc と背景タップで閉じる。
import { esc } from './dom';

const root = () => document.getElementById('overlay')!;
let stack: HTMLElement[] = [];
/** 閉じられるモーダルの閉じ方（左メニュー等で画面を移ったとき、まとめて閉じる） */
const closers = new Map<HTMLElement, () => void>();

export interface ModalOpts {
  title?: string;
  wide?: boolean;
  closable?: boolean;
  className?: string;
  onClose?: () => void;
}

export function openModal(html: string, opts: ModalOpts = {}) {
  const wrap = document.createElement('div');
  wrap.className = `modal-wrap ${opts.className ?? ''}`;
  wrap.innerHTML = `<div class="modal ${opts.wide ? 'wide' : ''}" role="dialog" aria-modal="true" ${opts.title ? `aria-label="${esc(opts.title)}"` : ''}>
    ${opts.title ? `<header class="modal-head"><h2>${esc(opts.title)}</h2>${opts.closable === false ? '' : '<button class="icon-btn close" data-close aria-label="閉じる">×</button>'}</header>` : ''}
    ${!opts.title && opts.closable !== false && !html.includes('data-close') ? '<button class="icon-btn close modal-x" data-close aria-label="閉じる">×</button>' : ''}
    <div class="modal-body">${html}</div></div>`;
  const close = () => {
    if (!wrap.isConnected) return;
    wrap.remove();
    stack = stack.filter((x) => x !== wrap);
    closers.delete(wrap);
    opts.onClose?.();
  };
  wrap.addEventListener('click', (e) => {
    const t = e.target as HTMLElement;
    if (opts.closable !== false && (t === wrap || t.closest('[data-close]'))) close();
  });
  root().appendChild(wrap);
  stack.push(wrap);
  if (opts.closable !== false) closers.set(wrap, close);
  const body = wrap.querySelector<HTMLElement>('.modal-body')!;
  queueMicrotask(() => wrap.querySelector<HTMLElement>('button, [tabindex], input')?.focus({ preventScroll: true }));
  return { el: wrap, body, close };
}

export const modalOpen = () => stack.length > 0;
export function closeTopModal() {
  const top = stack.at(-1);
  if (!top) return;
  const btn = top.querySelector<HTMLElement>('[data-close]');
  if (btn) btn.click();
  else closers.get(top)?.();
}
/** 閉じられるモーダルを上から全部閉じる（閉じられないものは残す） */
export function closeAllModals() {
  for (const w of [...stack].reverse()) closers.get(w)?.();
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && stack.length) closeTopModal();
});

export function confirmDialog(text: string, opts: { ok?: string; cancel?: string; danger?: boolean; severe?: boolean; title?: string } = {}): Promise<boolean> {
  return new Promise((resolve) => {
    let done = false;
    const m = openModal(
      `<p class="confirm-text">${esc(text).replace(/\n/g, '<br>')}</p>
       <div class="btn-row"><button class="btn" data-no>${esc(opts.cancel ?? 'やめる')}</button>
       <button class="btn ${opts.danger || opts.severe ? 'danger' : 'primary'}${opts.severe ? ' severe' : ''}" data-yes>${esc(opts.ok ?? 'はい')}</button></div>`,
      { title: opts.title ?? '確認', onClose: () => !done && resolve(false) },
    );
    m.body.addEventListener('click', (e) => {
      const t = e.target as HTMLElement;
      if (t.closest('[data-yes]')) {
        done = true;
        m.close();
        resolve(true);
      } else if (t.closest('[data-no]')) m.close();
    });
  });
}

export function toast(text: string, kind: 'info' | 'error' | 'good' = 'info', ms = 2200) {
  const el = document.createElement('div');
  el.className = `toast ${kind}`;
  el.textContent = text;
  document.getElementById('toasts')!.appendChild(el);
  setTimeout(() => el.classList.add('out'), ms);
  setTimeout(() => el.remove(), ms + 400);
}
